import axios from 'axios';
import {accessApiUrl} from "../helpers/config";

export default axios.create({
    baseURL: accessApiUrl
});